export const environment = {
  production: false,
  apiURL: "https://am-media-sports-api.vercel.app/api", //"http://localhost:4041/api",
  apiKey: "b6907d289e10d714a6e88b30761fae22",
};